import { deepCompare, evaluateFieldValueFilledAndValid } from "@/utils";
import { parse } from "@/utils/calculator-parser";

function evaluate(
  obj,
  operateOnValues,
  fieldIdToValueMaps,
  parentValues,
  layer
) {
  // eslint-disable-next-line no-console
  console.log("obj:", obj);
  switch (obj.type) {
    case "number":
      return parseFloat(obj.value);
    case "name":
      if (/^f/.test(obj.id)) {
        const fieldId = obj.id.substring(1);
        if (fieldId in fieldIdToValueMaps) {
          return fieldIdToValueMaps[fieldId];
        }
      } else if (/^pf/.test(obj.id)) {
        const fieldId = obj.id.substring(2);
        if (fieldId in parentValues) {
          return parentValues[fieldId];
        }
      }

      return null;
    case "+":
    case "-":
    case "/":
    case "*":
      return operateOnValues(
        obj.type,
        evaluate(
          obj.left,
          operateOnValues,
          fieldIdToValueMaps,
          parentValues,
          layer + 1
        ),
        evaluate(
          obj.right,
          operateOnValues,
          fieldIdToValueMaps,
          parentValues,
          layer + 1
        ),
        layer
      );
  }
}

export default {
  methods: {
    canLoadFormulaToField(field, formulaIndex = 0) {
      if (!this.initialized) {
        return false;
      }
      const { fieldIdToValueMaps } = this;
      let formula = field.math_formula;
      if(Array.isArray(field.math_formula)){
        formula = field.math_formula[formulaIndex]
      }

      if (!formula) {
        return false;
      }

      const currentValue = fieldIdToValueMaps[field.field_id];
      const formulaValue = this.getFieldValueByFormula(field, formulaIndex);
      // eslint-disable-next-line no-console
      console.log("currentValue:", currentValue, "formulaValue:", formulaValue);
      if (
        evaluateFieldValueFilledAndValid(currentValue, field) &&
        deepCompare(currentValue, formulaValue)
      ) {
        return false;
      }

      if (formulaValue === null || typeof formulaValue === "undefined") {
        return false;
      }

      return true;
    },
    /**
     * parse a math formula and return the evaluated result
     * @param mathFormula: e.g. "f2+f3"
     * @param operateOnValues {Function} a function to operate on values and get resultant value
     * @param fieldIdToValueMaps: maps from field id to value
     * @param parentValues: parent container values. Used for FormBox to access its parent DTEvent values
     **/
    evalMathFormula(
      mathFormula,
      operateOnValues,
      fieldIdToValueMaps,
      parentValues
    ) {
      return evaluate(
        parse(mathFormula),
        operateOnValues,
        fieldIdToValueMaps,
        parentValues,
        0
      );
    },
    /**
     * Update the value in this field by its math_formula
     */
    updateFieldByFormula(fieldTemplate, formulaIndex = 0) {
      let value = this.getFieldValueByFormula(fieldTemplate, formulaIndex);
      if (value !== null) {
        this.setInputValue(fieldTemplate["field_id"], value);
      }
    },
    getFieldValueByFormula(fieldTemplate, formulaIndex) {
      const { fieldIdToValueMaps, parentValues } = this;
      let { data_type, unit, math_formula, field_id } = fieldTemplate;
      if(Array.isArray(math_formula)){
        math_formula = math_formula[formulaIndex]
      }
      // eslint-disable-next-line no-console
      console.log("-----field:", unit, fieldTemplate);

      let operateOnValues;
      if (data_type === "decimal" || data_type === "integer") {
        operateOnValues = function (operator, a, b, layer) {
          // for a and b, there may be "amount" and <unit>.
          function extractAmountAndUnit(v) {
            let amount = null,
              unitValue = null;
            if (v !== null && typeof v === "object") {
              if ("amount" in v) {
                amount = v["amount"];
              }
              unitValue = v[unit] || null;
            } else if (typeof v === "number" && !isNaN(v)) {
              amount = v;
            }
            return { amount, unitValue };
          }

          const aCompactValue = extractAmountAndUnit(a);
          const bCompactValue = extractAmountAndUnit(b);

          if (aCompactValue.amount === null || bCompactValue.amount === null) {
            return null;
          }

          let resultAmount;
          switch (operator) {
            case "+":
              resultAmount = aCompactValue.amount + bCompactValue.amount;
              break;
            case "-":
              resultAmount = aCompactValue.amount - bCompactValue.amount;
              break;
            case "/":
              resultAmount = aCompactValue.amount / bCompactValue.amount;
              break;
            case "*":
              resultAmount = aCompactValue.amount * bCompactValue.amount;
              break;
            default:
              // eslint-disable-next-line no-console
              console.error("unknown operator:", operator);
              return null;
          }
          // eslint-disable-next-line no-console
          console.log("bCompactValue", bCompactValue, aCompactValue, a, b);

          if (unit) {
            if (unit === "percentage") {
              if (layer === 0) {
                // it's percentage, so times 100; and keep at most 2 decimal places
                resultAmount = Math.round(resultAmount * 100 * 100) / 100;
              }

              return {
                amount: resultAmount,
                [unit]: "%",
              };
            } else if (
              fieldTemplate.amount_can_calculate &&
              (bCompactValue.unitValue || aCompactValue.unitValue)
            ) {
              if (
                typeof aCompactValue.unitValue === "string" &&
                aCompactValue.unitValue.length
              ) {
                return {
                  amount: resultAmount,
                  [unit]: aCompactValue.unitValue,
                };
              } else if (
                typeof bCompactValue.unitValue === "string" &&
                bCompactValue.unitValue.length
              ) {
                return {
                  amount: resultAmount,
                  [unit]: bCompactValue.unitValue,
                };
              } else {
                return null;
              }
            } else if (
              aCompactValue.unitValue &&
              aCompactValue.unitValue === bCompactValue.unitValue
            ) {
              return {
                amount: resultAmount,
                [unit]: aCompactValue.unitValue,
              };
            } else {
              return null;
            }
          }

          return resultAmount;
        };
      } else {
        return null;
      }

      let value = null;
      try {
        value = this.evalMathFormula(
          math_formula,
          operateOnValues,
          fieldIdToValueMaps,
          parentValues
        );
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("error in evalMathFormula:", e, math_formula, field_id);
      }

      return value;
    },
  },
};
